"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.searchEndpointByAttrVal = exports.getObjectDifferences = exports.getIdString = exports.getDescendantProp = void 0;
/**
 * @param {object} obj Object to scan
 * @param {string} path json path
 * @param {string} splitter to use defaluts to '.'
 * @returns {any} result
 */
// eslint-disable-next-line import/prefer-default-export
const getDescendantProp = (obj, path, splitter = '.') => {
  let temp = obj;
  path.split(splitter).forEach(tk => {
    temp = temp && temp[tk];
  });
  return temp;
};

/**
 * @param {object} obj Object to scan
 * @param {string} idAttr array of strings or string
 * @returns {any} string
 */
// eslint-disable-next-line import/prefer-default-export
exports.getDescendantProp = getDescendantProp;
const getIdString = (obj, idAttr, prefixId) => {
  if (Array.isArray(idAttr)) {
    const temp = [];
    idAttr.forEach(ida => {
      temp.push(obj[ida]);
    });
    return prefixId ? `${prefixId}-${temp.join('-')}` : temp.join('-');
  } else {
    return prefixId ? `${prefixId}-${obj[idAttr]}` : obj[idAttr];
  }
};

/**
 * Lookup a list on the store for an attribute and match a val. The result is an array.
 * The result array is a clone of originals if clone is set to true.
 * @param {string} list xpath for list on the store.
 * @param {string} attr attribute to look for
 * @param {string} val value to match
 * @param {function} filter custom function to filter
 * @param {boolean} clone if found items are to be cloned.
 */
exports.getIdString = getIdString;
const searchEndpointByAttrVal = (list = [], attr, val, filter, clone = false) => {
  if (!list || !attr || !val) {
    return null;
  }
  if (!Array.isArray(list) && list.length === 0) {
    return null;
  }
  const items = [];
  const addItem = itm => {
    if (clone) {
      items.push(JSON.parse(JSON.stringify(itm)));
    } else {
      items.push(itm);
    }
  };
  list.forEach(ele => {
    const find = getDescendantProp(ele, attr);
    if (filter && typeof filter === 'function' && filter(find, val)) {
      addItem(ele);
    } else if (Array.isArray(find) && find.indexOf(val) > -1) {
      addItem(ele);
    }
  });
  // items.length === 1 ? items[0] :
  return items;
};
exports.searchEndpointByAttrVal = searchEndpointByAttrVal;
const getObjectDifferences = (obj1, obj2) => {
  const differences = {};
  for (let key in obj1) {
    if (obj1.hasOwnProperty(key) && !obj2.hasOwnProperty(key)) {
      differences[key] = {
        oldValue: obj1[key],
        newValue: undefined
      };
    } else if (obj1[key] !== obj2[key]) {
      differences[key] = {
        oldValue: obj1[key],
        newValue: obj2[key]
      };
    } else if (typeof obj1[key] === "object" && typeof obj2[key] === "object") {
      const nestedDiff = getObjectDifferences(obj1[key], obj2[key]);
      if (Object.keys(nestedDiff).length > 0) {
        differences[key] = nestedDiff;
      }
    }
  }
  for (let key in obj2) {
    if (obj2.hasOwnProperty(key) && !obj1.hasOwnProperty(key)) {
      differences[key] = {
        oldValue: undefined,
        newValue: obj2[key]
      };
    }
  }
  return differences;
};
exports.getObjectDifferences = getObjectDifferences;